import { Controller } from 'stimulus'
import { updateEntrants } from '~/site/pages/cart/common'

export default class extends Controller {
  static targets = ['showFirstEntrantField']

  async showFirstEntrant() {
    this.showFirstEntrantFieldTarget.value = '1'
    this.showFirstEntrantFieldTarget.form?.dispatchEvent(
      new Event('cart-customer-draft:first-entrant-revealed')
    )
    await updateEntrants()
    this.emptyFirstEntrant()
  }

  emptyFirstEntrant() {
    // Prevent the filled contact info from being copied to the new participant fields only after clicking 'Purchasing for someone else?' (i.e. in here)
    // In other scenarios the first participant might actually be the same as the main contact,
    // so we don't want to clear the fields in those cases
    const participantFields = document.querySelectorAll(
      '[aria-label="participant #1 fields"]'
    )

    // when multiple products, we show participants fields for each product,
    // so there could be more than one "participant #1 fields" on the page
    participantFields.forEach((participantField) => {
      const fields = participantField.querySelectorAll('input')
      fields.forEach((field) => {
        // Do not clear checkbox values; they are static and used for truthy submission (e.g. gift)
        // In any case, what we should do is to uncheck the input, but I don't think we care right now
        if (field.type === 'checkbox') {
          return
        }

        field.value = ''
      })
    })
  }
}
